export default async function convertFileToWebP(file,ext='webp', maxWidth=1200) {
    return new Promise((resolve, reject) => {
        try {
            var reader = new FileReader();

            reader.onload = function (event) {
                var img = new Image();

                img.onload = function () {
                    var aspectRatio = img.width / img.height;

                    // Calculate new width and height with maxWidth limit
                    var newWidth = Math.min(img.width, maxWidth);
                    var newHeight = newWidth / aspectRatio;

                    var canvas = document.createElement("canvas");
                    canvas.width = newWidth;
                    canvas.height = newHeight;

                    var context = canvas.getContext("2d");
                    context.drawImage(img, 0, 0, newWidth, newHeight);

                    canvas.toBlob(async function (blob) {
                        // Create a File object from the Blob with the original filename and a new file type of "image/webp"
                        var convertedFile = new File([blob], file.name.replace(/\.[^/.]+$/, "") + "."+ext, { type: `image/${ext}` });

                        // Execute the callback function with the converted image as a File object
                        resolve(convertedFile);
                    }, `image/${ext}`);
                };

                // Load the image
                img.src = event.target.result;
            };

            // Read the selected file as a data URL
            reader.readAsDataURL(file);
        } catch (error) {
            reject(error);
        }
    });
}
